import React, { PropsWithChildren } from "react";
import { SHARE_RECIPIENT_BASE_CLASS } from "./share-space-recipient-layout";
import SidebarNavigation from "organisms/sidebar-navigation/sidebar-navigation";
import AuthorizedHeader from "molecules/header/authorized-header";

const AuthenticatedSubscriberLayout: React.FC<PropsWithChildren> = ({
    children,
}) => {
    return (
        <div
            className={SHARE_RECIPIENT_BASE_CLASS}
            data-test-id="authenticated-sub-layout">
            <header className={`${SHARE_RECIPIENT_BASE_CLASS}__header`}>
                <AuthorizedHeader />
            </header>
            <div className={`${SHARE_RECIPIENT_BASE_CLASS}__sidebar`}>
                <SidebarNavigation />
            </div>
            {children}
        </div>
    );
};

export default AuthenticatedSubscriberLayout;
